import { clone } from '@jack-henry/frontend-utils/functions';
import { WausauStatementsProductModelDto } from '@treasury/api/bo';
import { CompanyProductFeature } from './company-product-feature.entity';

const defaultDto: WausauStatementsProductModelDto = {
    errorMessage: '',
    noStatementMessage: '',
    productDisplayName: '',
    selectAccountLabel: '',
    id: 0,
    productUniqueId: '',
    type: 'WausauStatements',
    isConfigurable: true,
};
export class WausauEStatementsProductFeature extends CompanyProductFeature<WausauStatementsProductModelDto> {
    constructor(dto: WausauStatementsProductModelDto = clone(defaultDto)) {
        super(dto);
    }

    public get productDisplayName() {
        return this.dto.productDisplayName;
    }

    public set productDisplayName(value: string) {
        this.dto.productDisplayName = value;
    }

    public get errorMessage() {
        return this.dto.errorMessage;
    }

    public set errorMessage(value: string) {
        this.dto.errorMessage = value;
    }

    public get noStatementMessage() {
        return this.dto.noStatementMessage;
    }

    public set noStatementMessage(value: string) {
        this.dto.noStatementMessage = value;
    }

    public get selectAccountLabel() {
        return this.dto.selectAccountLabel;
    }

    public set selectAccountLabel(value: string) {
        this.dto.selectAccountLabel = value;
    }
}
